var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useProfileContext } from '@marketing/profile/ProfileContext';
import { foregroundToBackgroundColorMap } from '@marketing/variables';
import { clsx } from 'clsx';
import { Back } from '../Buttons';
import Button from '../Buttons/Button';
/**
 *
 * @param formIdOrOnNext - The form ID or a function to handle the next button
 * click. Forms use a submit event from the next button. Pages use a click
 * event.
 */
function Footer(_a) {
    var currentSection = _a.currentSection, onPrevious = _a.onPrevious, disableNext = _a.disableNext, _b = _a.theme, theme = _b === void 0 ? 'dark' : _b, formIdOrOnNext = _a.formIdOrOnNext;
    var formId = typeof formIdOrOnNext === 'string' ? formIdOrOnNext : undefined;
    var onNext = typeof formIdOrOnNext === 'function' ? formIdOrOnNext : undefined;
    var serverLoading = useProfileContext().serverLoading;
    var backgroundColorStyle = foregroundToBackgroundColorMap[theme === 'dark' ? 'squash' : 'beige'];
    var paddingStyle = 'px-3 py-4 md:px-10 md:py-5';
    var flexStyles = 'w-full md:max-w-2xl mx-auto flex flex-row gap-4';
    var buttonText = serverLoading
        ? 'Submitting...'
        : currentSection === 'order'
            ? 'Place Order'
            : formId
                ? 'Submit'
                : 'Next';
    return (_jsx(_Fragment, { children: currentSection && currentSection !== 'start' && (_jsx("footer", __assign({ className: clsx(backgroundColorStyle, 'w-full sticky bottom-0 z-20 drop-shadow-[0_-1px_rgba(0,0,0,0.1)]') }, { children: _jsxs("div", __assign({ className: clsx(flexStyles, paddingStyle) }, { children: [onPrevious ? (_jsx(Back, { onClick: onPrevious })) : (_jsx("div", { className: "hidden md:block md:size-15" })), _jsx("div", __assign({ className: "flex-grow" }, { children: _jsx("div", __assign({ className: "w-full h-full md:w-[332px] mx-auto" }, { children: _jsx(Button, __assign({ disabled: disableNext || serverLoading, form: formId, onClick: onNext, theme: theme, type: formId ? 'submit' : 'button' }, { children: buttonText })) })) })), _jsx("div", { className: "hidden md:block md:size-15" })] })) }))) }));
}
export default Footer;
